import { Stack, Flex, Box, Text } from '@chakra-ui/core'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { AIPrompt } from '../fileds/AIPrompt'
import { PopRecipients } from '../fileds/PopRecipients'
import { PopSwitch } from '../fileds/PopSwitch'
import { ProfileImageField } from '../fileds/ProfileImageField'
import { PushMessageField } from '../fileds/PushMessageField'
import { PushTitleField } from '../fileds/PushTitleField'
import { TitleField } from '../fileds/TitleField'
import { UploadMediaSection } from '../fileds/UploadMediaSection'
import { PopType } from 'components/PopCreation/types'
import useLocaleText from 'components/useLocaleText'
import { MAX_TITLE_AI_LENGTH } from '../utils'
import { BtnTextField } from '../fileds/BtnTextField'

export const AIPop = () => {
  const { control } = useFormContext()
  const pick_audience = useLocaleText('pick_audience')
  const enable_push_notification = useLocaleText('enable_push_notification', true)
  const error_title_ai_length = useLocaleText('error_title_ai_length', true)

  return (
    <Stack style={{ gap: '15px' }}>
      <Stack style={{ gap: '10px' }}>
        <ProfileImageField />
        <TitleField maxLength={MAX_TITLE_AI_LENGTH} error_title_length={error_title_ai_length} />
        <AIPrompt keyName="data.pop_body" label="prompt" placeholder="prompt_placeholder" enableValidation={true} />
        <BtnTextField keyName="data.ack_btn_text" label="ack_btn" placeholder="ack_btn_placeholder" />
      </Stack>

      <Box>
        <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2}>
          {pick_audience}
        </Text>
        <PopRecipients />
      </Box>

      <UploadMediaSection />

      <Flex flexDir="column" mt={2} w={{ base: '100%', md: 'calc(50% - 10px)' }}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontSize="14px" fontWeight="bold" color="gray.500" mb={2} w="100%">
            {enable_push_notification}
          </Text>
          <PopSwitch name="is_send_push_notification" />
        </Flex>

        <PushTitleField
          keyName="data.push_title"
          label="push_title"
          placeholder="push_title_placeholder"
          keySwitch="is_send_push_notification"
        />
        <PushMessageField
          keyName="data.push_body"
          label="push_body"
          placeholder="push_body_placeholder"
          keySwitch="is_send_push_notification"
        />
      </Flex>
      <Controller name="pop_type" control={control} defaultValue={PopType.AiPop} as={<Box display="none" />} />
      <Controller name="rid" control={control} as={<Box display="none" />} />
    </Stack>
  )
}
